import { useEffect, useState } from "react";
import { isDespiaNative } from "@/lib/isDespiaNative";

/** El mismo corte que `useIsMobile` (1024 px): a partir de ahí es ordenador. */
const DESKTOP_QUERY = "(min-width: 1024px)";

/**
 * «Cambiar a Ulture Tactic» solo en la web de ordenador (Pablo, 04-11-2026: «en
 * móvil no puede estar»): ni por debajo de 1024 px ni en la app nativa, tampoco
 * en una tablet grande en horizontal. Se mide desde el primer pintado (no como
 * `useIsMobile`, que empieza en «no es móvil»), así en un teléfono el botón no
 * llega a asomar.
 */
export function useCanSwitchApps(): boolean {
  const [desktop, setDesktop] = useState<boolean>(
    () => typeof window !== "undefined" && window.matchMedia(DESKTOP_QUERY).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_QUERY);
    const onChange = () => setDesktop(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return desktop && !isDespiaNative();
}
